<template>
  <div>
    <el-card>
      <div slot="header">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" :model="conditions">
        <el-form-item>
          <el-input v-model="conditions.orderId" placeholder="订单ID" clearable />
        </el-form-item>
        <el-form-item>
          <el-input v-model="conditions.receiverTel" placeholder="联系电话" clearable />
        </el-form-item>
        <el-form-item>
          <el-input v-model="conditions.goodsName" placeholder="商品名称" clearable />
        </el-form-item>
        <el-form-item>
          <el-select v-model="conditions.state" placeholder="订单状态" clearable style="width: 140px">
            <el-option label="待处理" value="1001" />
            <el-option label="已发货" value="2002" />
            <el-option label="已完成" value="3003" />
            <el-option label="已取消" value="4004" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="queryList">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header">
        <span>兑换订单</span>
      </div>
      <el-table :data="orderList" border style="width: 100%">
        <el-table-column prop="orderId" label="订单ID" align="center" width="160" />
        <el-table-column prop="goodsName" label="商品名称" align="center" min-width="120" />
        <el-table-column label="商品图片" align="center" width="100">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.goodsImg"
              :src="scope.row.goodsImg"
              :preview-src-list="[scope.row.goodsImg]"
              style="width: 50px; height: 50px"
              fit="cover" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="userId" label="用户ID" align="center" width="160" />
        <el-table-column prop="pointsCost" label="消耗积分" align="center" width="100" />
        <el-table-column label="订单状态" align="center" width="100">
          <template slot-scope="scope">
            {{ getStateName(scope.row.state) }}
          </template>
        </el-table-column>
        <el-table-column prop="receiverName" label="收货人" align="center" width="100" />
        <el-table-column prop="receiverTel" label="联系电话" align="center" width="120" />
        <el-table-column prop="area" label="地区" align="center" min-width="120" show-overflow-tooltip />
        <el-table-column prop="detailAddress" label="详细地址" align="center" min-width="140" show-overflow-tooltip />
        <el-table-column prop="createTime" label="下单时间" align="center" width="160" />
        <el-table-column label="操作" align="center" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="openStateDialog(scope.row)">更新状态</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="margin-top-sm"
        :current-page="conditions.page"
        :page-size="conditions.row"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handlePageChange" />
    </el-card>

    <el-dialog title="更新订单状态" :visible.sync="stateDialogVisible" width="480px">
      <el-form label-width="100px">
        <el-form-item label="订单ID">
          <span>{{ currentOrder.orderId }}</span>
        </el-form-item>
        <el-form-item label="当前状态">
          <el-tag type="info">{{ getStateName(currentOrder.state) }}</el-tag>
        </el-form-item>
        <el-form-item label="新状态">
          <el-select
            v-model="newState"
            placeholder="请选择状态"
            style="width: 100%"
            popper-append-to-body>
            <el-option label="待处理" value="1001" />
            <el-option label="已发货" value="2002" />
            <el-option label="已完成" value="3003" />
            <el-option label="已取消" value="4004" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="stateDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitState">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  listPointsExchangeOrder,
  updatePointsExchangeOrder
} from '@/api/admin/pointsCheckIn/pointsCheckInApi'

const ORDER_STATE_OPTIONS = [
  { statusCd: '1001', name: '待处理' },
  { statusCd: '2002', name: '已发货' },
  { statusCd: '3003', name: '已完成' },
  { statusCd: '4004', name: '已取消' }
]

const ORDER_STATE_MAP = ORDER_STATE_OPTIONS.reduce((map, item) => {
  map[item.statusCd] = item.name
  return map
}, {})

function normalizeOrderState(state) {
  if (state == null || state === '') {
    return ''
  }
  return String(state).trim()
}

export default {
  name: 'PointsExchangeOrderManage',
  data() {
    return {
      orderList: [],
      total: 0,
      conditions: {
        orderId: '',
        receiverTel: '',
        goodsName: '',
        state: '',
        page: 1,
        row: 10
      },
      stateDialogVisible: false,
      currentOrder: {},
      newState: ''
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    getStateName(state) {
      const stateStr = normalizeOrderState(state)
      return ORDER_STATE_MAP[stateStr] || stateStr || '-'
    },
    async loadList() {
      try {
        const params = {
          page: this.conditions.page,
          row: this.conditions.row
        }
        if (this.conditions.orderId) {
          params.orderId = this.conditions.orderId
        }
        if (this.conditions.receiverTel) {
          params.receiverTel = this.conditions.receiverTel
        }
        if (this.conditions.goodsName) {
          params.goodsName = this.conditions.goodsName
        }
        if (this.conditions.state) {
          params.state = this.conditions.state
        }
        const res = await listPointsExchangeOrder(params)
        this.orderList = (res.data || []).map(row => ({
          ...row,
          state: normalizeOrderState(row.state)
        }))
        this.total = res.records || 0
      } catch (error) {
        console.error('获取兑换订单列表失败:', error)
      }
    },
    queryList() {
      this.conditions.page = 1
      this.loadList()
    },
    handlePageChange(page) {
      this.conditions.page = page
      this.loadList()
    },
    openStateDialog(row) {
      this.currentOrder = {
        ...row,
        state: normalizeOrderState(row.state)
      }
      this.newState = normalizeOrderState(row.state)
      this.stateDialogVisible = true
    },
    async submitState() {
      if (!this.newState) {
        this.$message.warning('请选择订单状态')
        return
      }
      try {
        const res = await updatePointsExchangeOrder({
          orderId: this.currentOrder.orderId,
          state: this.newState
        })
        if (res.code !== 0) {
          this.$message.error(res.msg || '更新失败')
          return
        }
        this.$message.success('更新成功')
        this.stateDialogVisible = false
        this.loadList()
      } catch (error) {
        console.error('更新订单状态失败:', error)
      }
    }
  }
}
</script>
